var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPractical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 377.953,
    height: 377.953,
    viewBox: "0 0 377.953 377.953",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 283.465h283.465V0H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33333 0 0 -1.33333 0 377.953)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(183.125 33.187)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bcbcbc",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-.197 1.461c1.018-.071 2.109.151 2.751-.286.534-.363.558-1.498.748-2.306.019-.08-.374-.351-.588-.366-.192-.014-.575.204-.575.318C2.148.324 1.152.181 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.191 86.417)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4993c1",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c21.99-20.975 47.476-29.453 76.855-24.987 46.091 7.006 77.411 48.474 74.429 92.528-.45 6.661-2.209 13.227-3.167 19.865-.195 1.349.488 2.824.767 4.241 1.148-1.004 2.957-1.801 3.347-3.043 8.126-25.847 6.06-50.947-6.302-75.036-10.381-20.229-26.099-34.991-46.913-44.226-56.96-25.273-121.775 7.404-135.49 68.287-15.122 67.13 43.69 129.175 111.487 117.558 4.65-.797 9.257-1.978 13.774-3.344 1.33-.402 2.283-2.053 3.409-3.132-1.613-.347-3.405-1.335-4.813-.944-18.486 5.14-36.685 4.36-54.751-1.975-47.354-16.606-71.552-72.428-51.093-118.241 2.326-5.207 5.057-10.313 8.239-15.035C-7.116 7.906-3.191 3.849 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.22 112.08)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4993c1",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c21.866-21.859 48.284-26.149 71.089-15.017C92.634-4.5 105.488 19.396 102.655 43.669c-.13 1.113-.57 2.287-.344 3.318.249 1.136 1.102 2.139 1.691 3.201.842-.768 2.11-1.388 2.437-2.333.684-1.979.972-4.116 1.248-6.212 3.586-27.251-9.965-53.968-34.185-67.463-23.668-13.188-53.554-10.542-74.708 6.615-26.84 21.769-32.846 60.412-13.705 89.208 16.2 24.37 44.194 33.958 69.205 28.764.365-.076.837-.009 1.086-.217 1.034-.863 2.003-1.806 2.995-2.719-1.202-.545-2.404-1.548-3.608-1.55-3.97-.007-7.95.636-11.911.517-25.319-.765-47.497-18.086-53.852-42.623C-16.553 30.719-11.15 11.876 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(172.024 110.349)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a1c74a",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-13.832 13.706a3.516 3.516 0 01-4.927 0L-32.591 0c-1.355-1.343-.903-2.441 1.005-2.441h7.985a4.297 4.297 0 01-.072-.713v-79.217a4.34 4.34 0 014.328-4.328h6.152a4.34 4.34 0 014.328 4.328v79.217c0 .244-.032.48-.072.713h7.932C.903-2.441 1.355-1.343 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(137.464 131.698)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#175583",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a3.517 3.517 0 01-3.484 3.484l-19.472.089c-1.908.009-2.365-1.088-1.016-2.437l5.646-5.646a4.293 4.293 0 01-.554-.452l-56.016-56.016a4.341 4.341 0 010-6.121l4.351-4.35a4.341 4.341 0 016.121 0l56.015 56.015c.172.173.315.363.452.555l5.609-5.609C-.999-21.837.098-21.38.089-19.472z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128.899 156.676)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#70bde5",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-13.706 13.831c-1.343 1.356-2.441.903-2.441-1.004v-8.07a4.223 4.223 0 01-1.173.183h-79.218a4.34 4.34 0 01-4.328-4.328V-5.54a4.341 4.341 0 014.328-4.328h79.218c.409 0 .797.076 1.173.183v-8.069c0-1.908 1.098-2.36 2.441-1.005L0-4.928A3.517 3.517 0 010 0"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPractical);
export default __webpack_public_path__ + "static/media/practical.4e0282a9b8455aed44951d76573bd4c1.svg";
export { ForwardRef as ReactComponent };